import React, { useState } from "react";
import ParentHeader from "../components/ParentHeader";
import ParentBottomNav from "../components/ParentBottomNav";
import ChildrenTab from "../components/ChildrenTab";
import TasksTab from "../components/TasksTab";
import ShopTab from "../components/ShopTab";
import StatisticsTab from "../components/StatisticsTab";
import "./ParentHome.css";

// + інші таби далі

function ParentHome() {
  const [activeTab, setActiveTab] = useState("children");

  return (
    <div className="parent-container">
      <div className="parent-shell">
        <ParentHeader />

        <main className="parent-content">
          {activeTab === "children" && <ChildrenTab />}
          {activeTab === "tasks" && <TasksTab />}
          {activeTab === "shop" && <ShopTab />}
          {activeTab === "stats" && <StatisticsTab />}
        </main>

        <ParentBottomNav activeTab={activeTab} setActiveTab={setActiveTab} />
      </div>
    </div>
  );
}

export default ParentHome;
